<div class="row nova-font-style adjustment-grid">
  <div class="col s12 m12 l12 xl12 remove-default-padding">
    <h2>Adjustment Reports</h2>
    <div *ngIf="operators && operators.View">
      <div [hidden]="initialLoading">
        <div>
          <kendo-tabstrip #adjtabstrip [animate]="true" [tabAlignment]="'justify'" (tabSelect)="onSelect($event)">
            <kendo-tabstrip-tab title="Create New Report" [selected]="true">
              <ng-template kendoTabContent>
                <app-create-adjustment-report [adjustmentDataItem]="editAdjustmentData" (isDataSaved)="adjustmentDataSaved($event)"></app-create-adjustment-report>
              </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="View Reports">
              <ng-template kendoTabContent>
                <app-view-adjustment-reports [accessOperators]="operators" [ownerRecords]="ownersList" (loadViewReport)="getViewReport($event)"></app-view-adjustment-reports>
              </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="Rejected Reports">
              <ng-template kendoTabContent>
                <app-rejected-adjustment-records [accessOperators]="operators" (loadCreateReport)="getViewReport($event)"></app-rejected-adjustment-records>
              </ng-template>
            </kendo-tabstrip-tab>
          </kendo-tabstrip>
        </div>
      </div>
    </div>
  </div>
</div>
